import { StorageService } from './../../../../services/storage/storage.service';
import { TiposCombustiveis } from './../../../../services/tipos-combustiveis/tipos-combustiveis.interface';
import { TiposCombustiveisService } from './../../../../services/tipos-combustiveis/tipos-combustiveis.service';
import { FichaCadastroTipo } from './../../ficha-cadastro-tipo';
import { Router } from '@angular/router';
import { ContextSharedService } from './../../../../context-shared/context-shared.service';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { finalize, take } from 'rxjs/operators';
import { FichaService } from '../../../ficha-veiculo.service';
import { Veiculo } from '../../model/veiculo';
import { FichaCadastroSharedService } from '../../shared/ficha-cadastro-shared.service';
import { ModalMessageComponent } from './../../../../shared/modais/modal-message/modal-message.component';
import { FichaCadastro } from '../../ficha-cadastro';

@Component({
  selector: 'app-ficha-cadastro-veiculo-info',
  templateUrl: './ficha-cadastro-veiculo-info.component.html',
  styleUrls: ['./ficha-cadastro-veiculo-info.component.scss'],
})
export class FichaCadastroVeiculoInfoComponent implements OnInit, OnDestroy {
  @Input() veiculo: Veiculo;
  @Input() veiculos: Veiculo[];
  @Input() isPesados?: boolean;
  @Input() dontShowButtons?: boolean;
  @Input() isAlterar?: boolean;
  @Input() isInformarManualmente?: boolean;
  @Input() fichaCadastro: FichaCadastro;
  @Output() remover: EventEmitter<void> = new EventEmitter();
  @Output() adicionar: EventEmitter<void> = new EventEmitter();
  @Output() salvar: EventEmitter<Veiculo> = new EventEmitter();
  @Output() changeForm: EventEmitter<any> = new EventEmitter();
  @Output() changeFormValid: EventEmitter<any> = new EventEmitter();

  @ViewChild('modalMessage', { static: true })
  modalMessage: ModalMessageComponent;

  form: FormGroup;

  listaTipoVeiculo = [];
  listaMarca = [];
  listaAnoModelo = [];
  listaModelo = [];
  listaVersao = [];
  listaTiposCombustiveis: TiposCombustiveis[] = [];

  isSelectedTipoVeiculo = false;
  isSelectedMarca = false;
  isSelectedAnoModelo = false;
  isSelectedModelo = false;
  isSelectedVersao = false;
  isSelectedCotacao = false;

  isLoadingTipoVeiculo = false;
  isLoadingMarca = false;
  isLoadingAnoModelo = false;
  isLoadingModelo = false;
  isLoadingVersao = false;
  isLoadingCotacao = false;

  private isAlive = false;

  private isSelectedUfLicenciamento = false;

  private codigoFornecedorCotacao: string;
  private isAlteracao = false;
  private isZeroKmSelecionado = false;

  private subsTipoVeiculo: Subscription;
  private subsMarca: Subscription;
  private subsModelo: Subscription;
  private subsVersao: Subscription;
  private subsCotacao: Subscription;
  private subsForm: Subscription;

  isSelectedTipoVeiculoAfterBlur = true;
  isSelectedMarcaAfterBlur = true;
  isSelectedAnoModeloAfterBlur = true;
  isSelectedModeloAfterBlur = true;
  isSelectedVersaoAfterBlur = true;

  public tipoVeiculo: string = '';

  public fichaCadastroTipo = FichaCadastroTipo;

  private readonly PLACA_INVALIDA: string = 'PLACA_INVALIDA';

  public isPlacaInvalida = false;

  public multipleOffer: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private fichaService: FichaService,
    private sharedService: FichaCadastroSharedService,
    private context: ContextSharedService,
    private router: Router,
    private tiposCombustiveisService: TiposCombustiveisService,
    private storageService: StorageService,
  ) {}

  ngOnInit() {
    this.buildForm();
    this.loadListaTipoVeiculo();
    this.patchForm();
    this.watchForm();
    this.setMultipleOffer();

    if (this.isInformarManualmente) {
      if (this.veiculo.pendencia.error !== this.PLACA_INVALIDA) {
        this.form.get('veiculoPlaca').setValue('');
        this.isPlacaInvalida = false;
      } else {
        this.isPlacaInvalida = true;
      }
      this.form.get('isZeroKm').setValue(true);
    }

    this.initisInformarManualmenteObservable();
    this.getTipoVeiculoRota();
    this.getTipoCombustiveis();
  }

  getTipoVeiculoRota() {
    const tipo = this.router.url.split('/').pop();
    switch (tipo) {
      case 'motocicletas':
        this.tipoVeiculo = 'motocicleta';
        break;
      case 'pesados':
        this.tipoVeiculo = 'pesado';
        break;
      default:
        this.tipoVeiculo = 'automovel';
        break;
    }
  }

  initisInformarManualmenteObservable() {
    this.sharedService.selecionarVeiculoManualObservable.subscribe(() => {
      if (
        (this.fichaCadastro._tipo ===
          FichaCadastroTipo.CORRECAO_PLACA_INVALIDA &&
          this.fichaCadastro.payload.tipoProduto === 'AUTOMOVEIS') ||
        this.fichaCadastro.payload.tipoProduto === 'MOTOCICLETAS'
      ) {
        this.form
          .get('veiculoPlaca')
          .setValue(this.fichaCadastro.payload.veiculos[0].placa);
        this.isPlacaInvalida = true;
      } else {
        this.form.get('veiculoPlaca').setValue('');
      }
      this.isInformarManualmente = true;
      this.form.get('isZeroKm').setValue(true);
      this.form.get('inserirManual').setValue(true);
    });
  }

  ngOnDestroy() {
    if (this.subsTipoVeiculo) {
      this.subsTipoVeiculo.unsubscribe();
    }
    if (this.subsMarca) {
      this.subsMarca.unsubscribe();
    }
    if (this.subsModelo) {
      this.subsModelo.unsubscribe();
    }
    if (this.subsVersao) {
      this.subsVersao.unsubscribe();
    }
    if (this.subsCotacao) {
      this.subsCotacao.unsubscribe();
    }
    if (this.subsForm) {
      this.subsForm.unsubscribe();
    }
    this.isAlive = false;
  }

  private buildForm(): void {
    this.form = this.formBuilder.group({
      veiculoPlaca: ['', [this.placaDuplicadaValidator()]],
      isUtilizacaoAgropecuaria: [false],
      isZeroKm: [false],
      isPrimeiroVeiculo: [false],
      ufLicenciamento: ['', Validators.required],
      veiculoCategoria: [''],
      veiculoMarca: [{ value: '', disabled: !this.isSelectedTipoVeiculo }],
      veiculoAno: [{ value: '', disabled: !this.isSelectedMarca }],
      veiculoModelo: [{ value: '', disabled: !this.isSelectedAnoModelo }],
      veiculoVersao: [{ value: '', disabled: !this.isSelectedModelo }],
      veiculoCor: [''],
      veiculoCombustivel: [''],
      cotacao: [''],
      inserirManual: [false],
    });
  }

  private patchForm(): void {
    if (this.veiculo) {
      this.isAlteracao = true;
      this.form.patchValue(this.veiculo);
      if (this.veiculo.isZeroKm) {
        this.onChangeTipoVeiculo(null);
        this.onChangeMarca(null);
        this.onChangeAnoModelo(null);
        this.onChangeModelo(null);
        this.isSelectedVersao = true;
      }
    }
  }

  private watchForm(): void {
    this.subsForm = this.form.valueChanges.subscribe(() => {
      this.changeForm.emit(this.form);
      this.changeFormValid.emit(this.formValid);
    });
  }

  loadListaTipoVeiculo() {
    this.clearList(['TipoVeiculo', 'Marca', 'AnoModelo', 'Modelo', 'Versao']);
    this.isLoadingTipoVeiculo = true;
    this.subsTipoVeiculo = this.fichaService
      .getTipoVeiculo()
      .pipe(
        take(1),
        finalize(() => {
          this.isLoadingTipoVeiculo = false;
        })
      )
      .subscribe((res) => {
        if (res.tipos) {
          res.tipos.forEach((tipo) => {
            // if ([1, 2, 4, 5].includes(tipo.id)) {
            this.listaTipoVeiculo.push(tipo);
            // }
          });
        }
        this.resetAlteracao();
      });
  }

  loadListaMarca() {
    this.clearList(['Marca', 'AnoModelo', 'Modelo', 'Versao', 'Cotacao']);
    this.isLoadingMarca = true;
    this.subsMarca = this.fichaService
      .getMarcaPorTipo(this.veiculoCategoria)
      .pipe(
        take(1),
        finalize(() => {
          this.isLoadingMarca = false;
        })
      )
      .subscribe((res) => {
        this.listaMarca = res.marcas;
        if (this.isAlteracao && this.veiculo && this.veiculo.veiculoMarca) {
          const veiculoMarca = this.listaMarca.find(
            (f) => f.id === this.veiculo.veiculoMarca.id
          );
          this.form.get('veiculoMarca').setValue(veiculoMarca);
        }
        this.resetAlteracao();
      });
  }

  loadListaAnoModelo() {
    this.clearList(['AnoModelo', 'Modelo', 'Versao', 'Cotacao']);

    if (this.isZeroKm && !this.isInformarManualmente) {
      this.handleListaAnoModelo(this.anoModeloVeiculoZero());
    } else {
      this.isLoadingAnoModelo = true;
      this.fichaService
        .getAnoModeloPorMarca(this.veiculoCategoria, this.veiculoMarca)
        .pipe(
            take(1),
            finalize(() => {
                this.isLoadingAnoModelo = false;
            })
        )
        .subscribe(
          (res) => this.handleListaAnoModelo(res.anosModelo),
          (error) => {
            this.modalMessage.show(
              'Não há ano de veículo para as características selecionadas.'
            );
          }
        );
    }
  }

  loadListaModelo() {
    this.clearList(['Modelo', 'Versao', 'Cotacao']);
    this.isLoadingModelo = true;
    this.subsModelo = this.fichaService
      .getModeloPorMarcaAno(
        this.veiculoCategoria,
        this.veiculoMarca,
        this.veiculoAno
      )
      .pipe(
        take(1),
        finalize(() => {
          this.isLoadingModelo = false;
        })
      )
      .subscribe(
        (res) => {
          this.listaModelo = res.modelos;
          if (this.isAlteracao && this.veiculo && this.veiculo.veiculoModelo) {
            const veiculoModelo = this.listaModelo.find(
              (f) => f.id === this.veiculo.veiculoModelo.id
            );
            this.form.get('veiculoModelo').setValue(veiculoModelo);
          }
          this.resetAlteracao();
        },
        () =>
          this.modalMessage.show(
            ' Não há modelo de veículo para as características selecionadas.'
          )
      );
  }

  loadListaVersao() {
    this.clearList(['Versao', 'Cotacao']);
    this.isLoadingVersao = true;
    this.subsVersao = this.fichaService
      .getVersaoPorMarcaModeloAno(
        this.veiculoCategoria,
        this.veiculoMarca,
        this.veiculoAno,
        this.veiculoModelo
      )
      .pipe(
        take(1),
        finalize(() => {
          this.isLoadingVersao = false;
        })
      )
      .subscribe(
        (res) => {
          this.listaVersao = res.versoes;
          if (this.isAlteracao && this.veiculo && this.veiculo.veiculoVersao) {
            const veiculoVersao = this.listaVersao.find(
              (f) => f.id === this.veiculo.veiculoVersao.id
            );
            this.form.get('veiculoVersao').setValue(veiculoVersao);
          }
          this.resetAlteracao();
        },
        (error) => {}
      );
  }

  onChangeTipoVeiculo(event) {
    this.isSelectedTipoVeiculo = true;
    this.resetAlteracao();
    this.resetCampos();
    this.loadListaMarca();
    this.onSelectedTipoVeiculoChange();
  }

  onChangeMarca(event) {
    this.isSelectedMarca = true;
    this.resetAlteracao();
    this.resetCampos();
    this.loadListaAnoModelo();
    this.onSelectedMarcaChange();
  }

  onChangeAnoModelo(event) {
    this.isSelectedAnoModelo = true;
    this.resetAlteracao();
    this.resetCampos();
    this.loadListaModelo();
    this.onSelectedAnoModeloChange();
  }

  onChangeModelo(event) {
    this.isSelectedModelo = true;
    this.resetAlteracao();
    this.resetCampos();
    this.loadListaVersao();
    this.onSelectedModeloChange();
  }

  onChangeVersao(event) {
    this.codigoFornecedorCotacao =
      this.listaVersao[event.target.selectedIndex - 1].codigoMolicar;
    this.isSelectedVersao = true;
    this.resetAlteracao();
    this.resetCampos();
  }

  onChangeUfLicenciamento(event) {
    this.form.get('ufLicenciamento').setValue(event.target.value);
    this.isSelectedUfLicenciamento = true;
  }

  onBlurTipoVeiculo(event) {
    this.isSelectedTipoVeiculoAfterBlur = event.target.selectedIndex > 0;
  }

  onBlurMarca(event) {
    this.isSelectedMarcaAfterBlur = event.target.selectedIndex > 0;
  }

  onBlurAnoModelo(event) {
    this.isSelectedAnoModeloAfterBlur = event.target.selectedIndex > 0;
  }

  onBlurModelo(event) {
    this.isSelectedModeloAfterBlur = event.target.selectedIndex > 0;
  }

  onBlurVersao(event) {
    this.isSelectedVersaoAfterBlur = event.target.selectedIndex > 0;
  }

  private handleListaAnoModelo(anos) {
    this.listaAnoModelo = anos;
    this.resetAlteracao();
  }

  private anoModeloVeiculoZero(): any[] {
    const anoAtual: number = new Date().getFullYear() - 2;
    const anos = [];
    for (let index = 0; index < 4; index++) {
      anos[index] = { anoModelo: anoAtual + index };
    }
    return anos;
  }

  clearList(lista: string[]) {
    if (!this.isAlteracao && lista && lista.length) {
      lista.forEach((item) => {
        switch (item) {
          case 'TipoVeiculo': {
            this.listaTipoVeiculo = [];
            this.isSelectedTipoVeiculo = false;
            this.form.get('veiculoCategoria').setValue(null);
            this.onSelectedTipoVeiculoChange();
            break;
          }
          case 'Marca': {
            this.listaMarca = [];
            this.isSelectedMarca = false;
            this.form.get('veiculoMarca').setValue(null);
            this.onSelectedMarcaChange();
            break;
          }
          case 'AnoModelo': {
            this.listaAnoModelo = [];
            this.isSelectedAnoModelo = false;
            this.form.get('veiculoAno').setValue(null);
            this.onSelectedAnoModeloChange();
            break;
          }
          case 'Modelo': {
            this.listaModelo = [];
            this.isSelectedModelo = false;
            this.form.get('veiculoModelo').setValue(null);
            this.onSelectedModeloChange();
            break;
          }
          case 'Versao': {
            this.listaVersao = [];
            this.isSelectedVersao = false;
            this.form.get('veiculoVersao').setValue(null);
            break;
          }
          case 'Cotacao': {
            this.isSelectedCotacao = false;
            this.form.get('cotacao').setValue(null);
            break;
          }
        }
      });
      this.isSelectedTipoVeiculoAfterBlur = true;
      this.isSelectedMarcaAfterBlur = true;
      this.isSelectedAnoModeloAfterBlur = true;
      this.isSelectedModeloAfterBlur = true;
      this.isSelectedVersaoAfterBlur = true;
    }
  }

  private placaDuplicadaValidator(): ValidatorFn {
    return (control: AbstractControl): Validators | null => {
      const value = control.value;

      if (
        value &&
        this.veiculos.some(
          (v) => v.veiculoPlaca === value && v.isEdit !== this.veiculo.isEdit
        )
      ) {
        return { duplicidade: true };
      }

      return null;
    };
  }

  resetAlteracao() {
    if (
      !this.isLoadingTipoVeiculo &&
      !this.isLoadingMarca &&
      !this.isLoadingAnoModelo &&
      !this.isLoadingModelo &&
      !this.isLoadingVersao &&
      !this.isLoadingCotacao
    ) {
      this.isAlteracao = false;
    }
  }

  public get veiculoPlaca(): string {
    return (
      this.form &&
      this.form.get('veiculoPlaca') &&
      this.form.get('veiculoPlaca').value
    );
  }

  public get isZeroKm(): boolean {
    return (
      this.form && this.form.get('isZeroKm') && this.form.get('isZeroKm').value
    );
  }

  public get veiculoCategoria(): string {
    return (
      this.form &&
      this.form.get('veiculoCategoria') &&
      this.form.get('veiculoCategoria').value
    );
  }

  public get veiculoMarca(): string {
    return (
      this.form &&
      this.form.get('veiculoMarca') &&
      this.form.get('veiculoMarca').value &&
      this.form.get('veiculoMarca').value.id
    );
  }

  public get veiculoAno(): string {
    return (
      this.form &&
      this.form.get('veiculoAno') &&
      this.form.get('veiculoAno').value
    );
  }

  public get veiculoModelo(): string {
    return (
      this.form &&
      this.form.get('veiculoModelo') &&
      this.form.get('veiculoModelo').value &&
      this.form.get('veiculoModelo').value.id
    );
  }

  public get veiculoVersao(): string {
    return (
      this.form &&
      this.form.get('veiculoVersao') &&
      this.form.get('veiculoVersao').value &&
      this.form.get('veiculoVersao').value.id
    );
  }

  public get ufLicenciamento(): string {
    return (
      this.form &&
      this.form.get('ufLicenciamento') &&
      this.form.get('ufLicenciamento').value
    );
  }

  public get cotacao(): number {
    return (
      this.form && this.form.get('cotacao') && this.form.get('cotacao').value
    );
  }

  public get canAdd(): boolean {
    if (
      this.fichaCadastro &&
      this.fichaCadastro._tipo &&
      this.fichaCadastroTipo.CORRECAO_FIPE_NOT_FOUND ===
        this.fichaCadastro._tipo
    ) {
      return false;
    }
    return (
      (this.veiculos.length === 1 || this.veiculos.every((v) => v.saved)) &&
      !this.veiculo.isEdit
    );
  }

  public get unicoVeiculoEditandoManualmente(): boolean {
    return this.isInformarManualmente && this.veiculos.length === 1;
  }

  public get formValid(): boolean {
    const {
      isZeroKm,
      ufLicenciamento,
      veiculoCategoria,
      veiculoMarca,
      veiculoAno,
      veiculoModelo,
      veiculoVersao,
      veiculoCor,
      veiculoCombustivel,
    } = this.form.getRawValue();

    if (
      isZeroKm ||
      (this.fichaCadastro &&
        this.fichaCadastroTipo.CORRECAO_FIPE_NOT_FOUND ===
          this.fichaCadastro._tipo)
    ) {
      return !!(
        ufLicenciamento &&
        veiculoCategoria &&
        veiculoMarca &&
        veiculoAno &&
        veiculoModelo &&
        veiculoVersao &&
        (this.isAlterar ||
          (!this.isAlterar && veiculoCor && veiculoCombustivel))
      );
    }

    return ufLicenciamento && this.form.get('veiculoPlaca').valid;
  }

  public onClickVeiculoKM(): void {
    this.form.get('veiculoPlaca').setValue('');
    this.isZeroKmSelecionado = this.form.get('isZeroKm').value;
  }

  public onClickCancelar(): void {
    this.isInformarManualmente = false;
    this.remover.emit();
  }

  public onClickSalvar(): void {
    if (this.isInformarManualmente) {
      this.form.get('isZeroKm').setValue(false);
    }
    this.isInformarManualmente = false;
    this.salvar.emit(this.form.getRawValue());
    this.form.reset();
  }

  public onClickAdd(): void {
    if (this.veiculos && this.veiculos.length === 1) {
      this.onClickSalvar();
    }
    this.adicionar.emit();
    this.form.reset();
  }

  resetCampos() {
    this.form.get('veiculoCor').setValue(null);
    this.form.get('veiculoCombustivel').setValue(null);
  }

  getTipoCombustiveis() {
    this.tiposCombustiveisService
      .getTipoCombustiveis()
      .pipe(take(1))
      .subscribe((tipocombustivel: TiposCombustiveis[]) => {
        this.listaTiposCombustiveis = tipocombustivel;
      });
  }

  setMultipleOffer() {
    this.multipleOffer = this.storageService.getLocal().multiplesOffers;
  }

  onSelectedTipoVeiculoChange() {
    if (this.isSelectedTipoVeiculo) {
      this.form.get('veiculoMarca')?.enable();
    }
    else {
      this.form.get('veiculoMarca')?.disable();
    }
  }

  onSelectedMarcaChange() {
    if (this.isSelectedMarca) {
      this.form.get('veiculoAno')?.enable();
    } else {
      this.form.get('veiculoAno')?.disable();
    }
  }

  onSelectedAnoModeloChange() {
    if (this.isSelectedAnoModelo) {
      this.form.get('veiculoModelo')?.enable();
    } else {
      this.form.get('veiculoModelo')?.disable();
    }
  }

  onSelectedModeloChange() {
    if (this.isSelectedModelo) {
      this.form.get('veiculoVersao')?.enable();
    } else {
      this.form.get('veiculoVersao')?.disable();
    }
  }
}
